import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar/Sidebar";
import LabelHeader from "../../Components/Commons/LabelHeader";
import TextField from "../../Components/Commons/Forms/TextField";
import BtnSave from "../../Components/Commons/Buttons/BtnSave";
import { Radio } from "antd";
import { toast } from "react-toastify";
import { checkPhilhealthIsRegistered } from "../../Components/Helpers/API/PhilhealthApi/PhilhealthApi";
import { fetchPatientSearch } from "../../Components/Helpers/API/PatientApi/PatientApi";

function IsRegisteredCheck() {
  const navigate = useNavigate();
  const [phicPin, setPhicPin] = useState("");
  const [membership, setMembership] = useState("member");
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    setLoading(true);
    localStorage.setItem("phic_pin", phicPin);
    localStorage.setItem("phic_membership_type", membership);
    const code = membership === "member" ? "MM" : "DD";
    const res = await checkPhilhealthIsRegistered(phicPin, code);
    if (res && res.status === 200) {
      let registered;
      const d = res?.data;
      let candidate;
      if (Array.isArray(d)) {
        const item = d[0] || {};
        candidate =
          item?.isMemberDependentRegistered ??
          item?.is_registered ??
          item?.status ??
          item?.message ??
          item?.result;
      } else {
        candidate =
          (typeof d === "string" ? d : undefined) ??
          d?.isMemberDependentRegistered ??
          d?.data?.isMemberDependentRegistered ??
          d?.data?.is_registered ??
          d?.is_registered ??
          d?.data?.status ??
          d?.status ??
          d?.data?.message ??
          d?.message ??
          d?.result;
      }
      if (typeof candidate === "string") {
        const v = candidate.toUpperCase();
        registered = v === "YES" || v.includes("YES") ? true : v === "NO" || v.includes("NO") ? false : undefined;
      } else if (typeof candidate === "boolean") {
        registered = candidate;
      } else if (typeof candidate === "number") {
        registered = candidate === 1;
      }
      
      // If patient is NOT registered to PhilHealth, redirect to dashboard and remove queue
      if (registered === false) {
        toast.error("Patient is NOT registered to PhilHealth. Redirecting to dashboard.");
        
        setLoading(false);
        navigate("/dashboard");
        return;
      }
      
      if (registered === true) {
        toast.success("PhilHealth membership verified successfully.");
      } else if (registered === undefined) {
        toast.info("PhilHealth membership status unclear.");
      }
      const searchRes = await fetchPatientSearch({
        search: phicPin,
        page: 1,
      });
      const rows = Array.isArray(searchRes?.data?.data)
        ? searchRes.data.data
        : [];
      if (rows.length === 0) {
        navigate("/patients/add/new-patient", {
          state: { phic_pin: phicPin, phic_membership_type: membership },
        });
      } else {
        const firstId = rows[0]?.id;
        if (firstId) {
          navigate(`/patients/vitals/${firstId}`);
        } else {
          navigate("/patients/add/new-patient", {
            state: { phic_pin: phicPin, phic_membership_type: membership },
          });
        }
      }
    } else {
      // API call failed - treat as not registered
      toast.error("PhilHealth verification failed. Patient not registered.");
      
      setLoading(false);
      navigate("/dashboard");
      return;
    }
    setLoading(false);
  };

  return (
    <div className="App">
      <Sidebar />
      <div className="add-customer col p-4 pt-4 overflow-scroll">
        <LabelHeader text={"PHILHEALTH REGISTRATION CHECK"} />
        <div className="pt-2 ml-7">
          <div className="row">
            <div className="col-sm-6">
              <TextField
                required
                id="phic_pin"
                name="phic_pin"
                formLabel={`PhilHealth Identification Number (PIN)`}
                size={`sm`}
                value={phicPin}
                onChange={(e) => setPhicPin(e.target.value)}
                maxLength={12}
              />
            </div>
            <div className="col-sm-6">
              <div className="row">
                <span>Membership</span>
                <Radio.Group
                  value={membership}
                  onChange={(e) => setMembership(e.target.value)}
                >
                  <Radio value="member">Member</Radio>
                  <Radio value="dependent">Dependent</Radio>
                </Radio.Group>
              </div>
            </div>
          </div>
          <div className="row justify-content-end mt-5 mb-3">
            <div className="col-2">
              <BtnSave
                label={"Search"}
                size={"sm"}
                onClick={handleSearch}
                isClicked={loading}
                disabled={!phicPin || phicPin.length !== 12 || !membership}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IsRegisteredCheck;
